import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles, Typography, Grid } from '@material-ui/core'
import styles from './styles'
import FormTypes from './FormTypes'
import TextField from './TextField'
import language from 'utils/vast-languagepack'
import Stepper from '../Stepper'
import EmbedCode from './Main/PreviewView/EmbedCode'
import ResponseView from './Main/ResponseView'
import Build from './Build'
import Groups from './Groups'

export default connect(
  state => ({
    stepper: state.view.stepper.form,
  }),
  null,
)(
  withStyles(styles)(({ classes, stepper }) => {
    const steps = [
      <Grid container spacing={24} className={classes.grid}>
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            What should we call this form?
          </Typography>
          <TextField
            property="formName"
            label={language.signupform.add.labels.formName}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            For those who submit the form, what groups should we add them to?
          </Typography>
          <Groups />
        </Grid>
        <Grid item xs={12}>
          <FormTypes />
        </Grid>
      </Grid>,
      <Build />,
      <EmbedCode />,
      <ResponseView />,
    ]

    return (
      <Fragment>
        <Stepper />
        {steps[stepper]}
      </Fragment>
    )
  }),
)
